var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnselectedSmileyKnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    enableBackground: "new 0 0 1024 1024",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#DBDBDB",
    cx: 512,
    cy: 512,
    r: 452.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3158 -0.9488 0.9488 0.3158 -33.5461 532.8659)",
    fill: "#333333",
    cx: 352.7,
    cy: 289.7,
    rx: 90.1,
    ry: 58.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9974 -7.137746e-02 7.137746e-02 0.9974 -22.0392 51.1918)",
    fill: "#333333",
    cx: 705.3,
    cy: 334,
    rx: 58.8,
    ry: 90.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M641.1,639.1c-34.7,26.1-82.8,42.3-149.3,33.9c-66.5-8.4-109.1-35.9-136.3-69.8 c-59.1-73.6-45.2-177-45.2-177l418.4,52.6C728.7,478.8,716.6,582.4,641.1,639.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M641.1,639.1c-34.7,26.1-82.8,42.3-149.3,33.9c-66.5-8.4-109.1-35.9-136.3-69.8 c34.7-26.1,82.8-42.3,149.3-34C571.3,577.6,613.9,605.2,641.1,639.1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M310.3,426.2l418.4,52.6c0,0-119.5,26.7-207.2,13.5C439,479.9,310.3,426.2,310.3,426.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#DBDBDB",
    strokeWidth: 13.8,
    strokeMiterlimit: 10,
    cx: 512,
    cy: 512,
    r: 499.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnselectedSmileyKnow);
export default __webpack_public_path__ + "static/media/unselected-smiley-know.a06e5d925550a1fcf7dc7ae3f6c4739e.svg";
export { ForwardRef as ReactComponent };